/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * When using the Zoom SDK with Angular,
 * you must run the SDK outside the Angular zone
 * https://developers.zoom.us/docs/meeting-sdk/web/component-view/import-sdk/
 */
// disable patching requestAnimationFrame
(window as any).__Zone_disable_requestAnimationFrame = true;

// disable patching specified eventNames
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['message'];
